export enum OtherPreviewFileFormats {
    PDF = ".pdf",
    FORGE = "forge",
}

export enum MediaFileFormats {
    PNG = ".png",
    JPG = ".jpg",
    MP4 = ".mp4",
    MOV = ".mov",
}

export type InsightPreviewFileFormats =
    | OtherPreviewFileFormats
    | MediaFileFormats;
export const InsightPreviewFileFormats = {
    ...OtherPreviewFileFormats,
    ...MediaFileFormats,
};
